export default __webpack_public_path__ + "static/tennis-ball-02141646c5cbaa84dd20342af61f1945.jpg";